<template functional>
    <b-table-lite :items="props.items" :fields="['created_at', 'max_temp', 'min_temp', 'wind_speed']">
        <template #head(created_at)>
            {{ parent.$t('Date') }}
        </template>

        <template #head(max_temp)>
            <fa icon="temperature-high" class="mr-1" />
            {{ parent.$t('Max temp') }}
        </template>

        <template #head(min_temp)>
            <fa icon="temperature-low" class="mr-1" />
            {{ parent.$t('Min temp') }}
        </template>

        <template #head(wind_speed)>
            <fa icon="wind" class="mr-1" />
            {{ parent.$t('Wind speed') }}
        </template>

        <template #cell(created_at)="{value}">
            <strong>{{ parent.$moment(value).format('lll') }}</strong>
        </template>

        <template #cell(max_temp)="{value}">
           <span v-html="value"/>
        </template>

        <template #cell(min_temp)="{value}">
             <span v-html="value"/>
        </template>

        <template #cell(wind_speed)="{value}">
             <span v-html="value"/>
        </template>
    </b-table-lite>
</template>
<script>
    export default {
        name: 'ProjectWeatherTable',
        props: {
            items: {
                type: Array,
                required: true
            }
        }
    }
</script>
